import React from 'react';
import '../css/Footer.css';
import { FaMapMarkerAlt, FaPhoneAlt, FaClock, FaFacebook, FaLinkedin, FaInstagram } from 'react-icons/fa';
import { FaTwitter } from 'react-icons/fa6';
import { IoMail } from "react-icons/io5";


const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Main Footer Content */}
        <div className="footer-main">
          {/* Company Info */}
          <div className="footer-section company-info">
            <div className="logo-section">
              <div className="company-brand">
                <h3 className="company-name">Techsol Technologies</h3>
              </div>
              <p className="company-tagline">
                 Techsol Technologies Transforming Ideas Into Digital Reality
              </p>
            </div>
            <p className="company-description">
              We provide cutting-edge technology solutions to help businesses 
              thrive in the digital age. From software development to AI solutions, 
              we're your trusted technology partner.
            </p>
            <div className="social-links">
              <a href="#" className="social-link-footer" aria-label="LinkedIn">
                <FaLinkedin />
              </a>
              <a href="#" className="social-link-footer" aria-label="Twitter">
                <FaTwitter />
              </a>
              <a href="#" className="social-link-footer" aria-label="Facebook">
                <FaFacebook />
              </a>
              <a href="#" className="social-link-footer" aria-label="Instagram">
                <FaInstagram />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4 className="footer-title">Quick Links</h4>
            <ul className="footer-links">
              <li><a href="/about">About Us</a></li>
              <li><a href="/services">Services</a></li>
              <li><a href="/projects">Projects</a></li>
              <li><a href="/contact">Contact</a></li>
            </ul>
          </div>

          {/* Services */}
          <div className="footer-section">
            <h4 className="footer-title">Our Services</h4>
            <ul className="footer-links">
              <li><a href="/web-development">Web Development</a></li>
              <li><a href="/app-development">Mobile Applications</a></li>
              <li><a href="/laravel">Laravel Development</a></li>
              <li><a href="/artificial-intelligence">AI & ML</a></li>
              <li><a href="/seo-optimization">SEO Optimization</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h4 className="footer-title">Get in Touch</h4>
            <div className="contact-info-footer">
              <div className="contact-item">
                <div className="contact-icon-footer">
                  <FaMapMarkerAlt />
                </div>
                <div className="contact-text">
                  <span>Collabs Lahore, Gulberg III, Lahore, Pakistan</span>
                  <span></span>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon-footer">
                  <FaPhoneAlt />
                </div>
                <span>+92 (319) 328-4118</span>
              </div>
              <div className="contact-item">
                <div className="contact-icon-footer">
                  <IoMail />
                </div>
                <span>info@techsoltech.com</span>
              </div>
            </div>
          </div>
        </div>


        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div className="copyright">
              <p>&copy; {new Date().getFullYear()} Techsol Technologies. All rights reserved.</p>
            </div>
            <div className="footer-legal">
              <a href="/privacy-policy">Privacy Policy</a>
              <a href="/privacy-policy">Terms of Service</a>
              <a href="/cookies">Cookie Policy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;